import React from 'react'
import { connect } from 'dva'
import { modelUtils } from '../../../../utils'
import { framework_tool, component_tool, utils_tool } from '@/tool'
import { QsPreview } from '@/components'
let { WizContainer } = framework_tool
let { WizSpin } = component_tool
let { Session } = utils_tool

const getParamRecord = (history, templateData) => {
  let record = {}
  if (templateData && templateData['id']) {
    record = templateData
  } else {
    if (history.location && history.location.pathname === '/biz/surveyTemplate/surveyTemplatePreview') {
      if (history.location && history.location.record) {
        record = history.location.record
        Session.set('surveyTemplatePreview', record)
      } else {
        record = Session.get('surveyTemplatePreview') || {}
      }
    }
  }
  return record
}

class SurveyTemplatePreview extends WizContainer {

  componentName = 'SurveyTemplatePreview'

  constructor(props) {
    super(props)
    let { history, templateData } = props
    this._surveyTemplate = getParamRecord(history,templateData)
    this.state = {
      surveyTemplateId: this._surveyTemplate.id,
    }
  }

  _componentDidMount() {
    this.doAction({
      path: 'surveyTemplate/getSurveyTemplateInfo',
      payload: {
        key: 'surveyTemplatePreview_' + this.state.surveyTemplateId,
        apiParams: { id: this.state.surveyTemplateId }
      }
    })
  }

  _onSubmit = () => {
    WizNotice.warn('当前为问卷模版预览页面，只能预览，不能提交！')
  }

  _render() {
    let { code, data } = this.props.surveyTemplatePreview
    if (code !== 1) {
      data = {
        title: this._surveyTemplate.title,
        intro: this._surveyTemplate.intro
      }
    }
    return (
      <>
        <WizSpin tip={'加载中'} spinning={this.props.surveyTemplateLoading}>
          <QsPreview data={ { ...data, preview: true } } onSubmit={this._onSubmit}/>
        </WizSpin>
      </>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { surveyTemplate } = state
  const { history,templateData } = ownProps
  let record = getParamRecord(history,templateData)
  const surveyTemplatePreview = modelUtils.getModelEntity(surveyTemplate, 'surveyTemplatePreview_' + record.id)
  const load = modelUtils.getLoadingState(state, 'surveyTemplate')
  return {
    surveyTemplatePreview,
    ...load
  }
}

export default connect(mapStateToProps)(SurveyTemplatePreview)
